export function teePairLabel(value: string): string {
  try {
    const sides: unknown = JSON.parse(value);
    if (!Array.isArray(sides) || sides.length !== 2)
      return "Recorded tee pairing";
    const names = sides.map((side: unknown) =>
      Array.isArray(side)
        ? side
            .map((tee: unknown) =>
              Array.isArray(tee) && typeof tee[1] === "string"
                ? tee[1]
                : "Unknown tee",
            )
            .join(" + ")
        : "Unknown tee",
    );
    return names.join(" · ") + simulatorTeeLabel(sides);
  } catch {
    return value.trim().length > 0 &&
      value.length < 100 &&
      !["[", "]", "{", "}"].some((token) => value.includes(token))
      ? value
      : "Recorded tee pairing";
  }
}

function simulatorTeeLabel(sides: unknown[]): string {
  const first: unknown = Array.isArray(sides[0]) ? sides[0][0] : undefined;
  const basis: unknown = Array.isArray(first) ? first[3] : undefined;
  if (!basis || typeof basis !== "object" || !("simulator" in basis)) return "";
  const settings = basis.simulator as {
    system?: string;
    gimme?: { mode?: string; distance?: number; unit?: string };
  } | null;
  if (!settings) return " · Gimme unknown";
  return ` · ${settings.system ?? "Simulator"} · ${settings.gimme?.mode === "off" ? "Gimme off" : `Gimme ${settings.gimme?.distance ?? "?"} ${settings.gimme?.unit ?? ""}`}`;
}
